import 'modern-normalize/modern-normalize.css';
import '../scss/main.scss';

import { initAccordion } from './modules/accordion.js';
import { initBackgroundVideo } from './modules/background-video.js';
import { initContactForm } from './modules/contact-form.js';
import { initHeader } from './modules/header.js';
import { initHeroSlider, initLegacySlider } from './modules/hero-slider.js';
import { initLoader } from './modules/loader.js';

const init = () => {
  initLoader();
  initHeader();
  initAccordion();
  initHeroSlider();
  initLegacySlider();
  initBackgroundVideo();
  initContactForm();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init, { once: true });
} else {
  init();
}
